// The password rule, in one place.
//
// Four screens set a password — the sign-in screen's create-account form, a
// staff invitation, a manager's registration wizard, and a reset — and they must
// not disagree about what an acceptable one is. `PasswordRequirements` renders
// these same two checks.

/**
 * Minimum password we accept, from the partner-register.html mock. Stricter than
 * Firebase's own six-character floor, which is why the check has to be ours:
 * `auth/weak-password` will not fire at seven characters, so every form refuses
 * to submit before Firebase is asked.
 */
export const MIN_PASSWORD_LENGTH = 8;

export interface PasswordCheckType {
  longEnough: boolean;
  matches: boolean;
  /** Both of the above — what a submit button should gate on. */
  ok: boolean;
}

export function checkPassword(password: string, confirmPassword: string): PasswordCheckType {
  const longEnough = password.length >= MIN_PASSWORD_LENGTH;
  // An empty pair is not a match: two blank fields are equal, and would
  // otherwise light the tick before anything had been typed.
  const matches = !!password && password === confirmPassword;
  return { longEnough, matches, ok: longEnough && matches };
}
